<ng-container *ngIf="price !== undefined; else loading">
  <div>
    <div class="price">
      <span class="currency body-5">
        {{ 'COMMON.CURRENCY_PER_MONTH' | translate }}
      </span>
      <span class="amount body-1 bold">
        <ng-container *ngIf="!isExactPrice">
          {{ 'INSURANCE_CARD.AMOUNT' | translate }}
        </ng-container>
        <ssc-price [price]="price"></ssc-price>
      </span>
    </div>
    <div *ngIf="discount">
      <span class="currency body-5">
        {{ 'COMMON.FRAMEWORK_CONTRACT_DISCOUNT' | translate: { discount: discount } }}
      </span>
    </div>
  </div>
  <div class="actions">
    <ng-content select="[action-button]"></ng-content>
  </div>
</ng-container>

<ng-template #loading>
  <dap-lib-skeleton-loader
    *dapLibShowForBreakpoint="'for-Small-Down'"
    [colorVariant]="loaderColorVariant"
    size="stretch"
  ></dap-lib-skeleton-loader>
  <dap-lib-skeleton-loader
    [colorVariant]="loaderColorVariant"
    *dapLibHideForBreakpoint="'for-Small-Down'"
    size="medium"
  ></dap-lib-skeleton-loader>
</ng-template>
